



































































import { NavigationMixin } from '@/mixins/navigationMixin'
import { apiRoutes } from '@/helpers/ApiRoutes'
import { LOGGED_IN_USER } from '@/store'

export default NavigationMixin.extend({
  name: 'AccountMenu',
  data: () => ({
    user: {
      fullName: '',
      email: '',
      avatar: ''
    },
    defaultAvatar: 'data:image/png;base64,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',
    accountUrl: process.env.VUE_APP_MENU_ACCOUNT
  }),
  methods: {
    goToSettings () {
      window.location.href = this.accountUrl
    },
    logout () {
      localStorage.removeItem(LOGGED_IN_USER)
      this.goToPage(apiRoutes.apiLogout)
    }
  },
  computed: {
    getAvatar () {
      return this.user.avatar !== ''
        ? this.user.avatar
        : this.defaultAvatar
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem(LOGGED_IN_USER) as string)
  }
})
